/* eslint-disable import/no-anonymous-default-export */
export const headerKey: string = process.env.REACT_APP_HEADER_KEY;
export const headerValue: string = process.env.REACT_APP_HEADER_VALUE;
export const PROTOCOL: string = process.env.REACT_APP_API_PROTOCOL;
export const DOMAIN: string = process.env.REACT_APP_API_DOMAIN;
export const BASE_DOMAIN: string = process.env.REACT_APP_API_BASE_URL;
export const GOOGLE: string = process.env.REACT_APP_GOOGLE_KEY;
export const PYTHON_DOMAIN: string = process.env.REACT_APP_API_DOMAIN_PYTHON;
export const INQUIRY_API_KEY: string = process.env.REACT_APP_INQUIRY_API_KEY;
export const INQUIRY_ORIGIN: string = process.env.REACT_APP_INQUIRY_ORIGIN;

export default {
  API: {
    URL: `${PROTOCOL}://${DOMAIN}/api/v1/`,
    BASE_URL: `${PROTOCOL}://${BASE_DOMAIN}/api/v1/`,
    HEADER_KEY: headerKey,
    HESDER_VALUE: headerValue,
  },
  PYTHON_API: `${PROTOCOL}://${PYTHON_DOMAIN}/`,
  KEYS: {
    GOOGLE: GOOGLE,
  },
  INQUIRY_API_KEY: INQUIRY_API_KEY,
  INQUIRY_ORIGIN: INQUIRY_ORIGIN,
};
